import { useContext } from "react";
import { User, Puzzle, Clock, Users, FileText, CheckCircle, Bot, Building2, Target, AtSign, History, FileSpreadsheet } from "lucide-react";
import { WhatsAppIcon } from "./icons/whatsAppIcon";
import NavigationSection from "./NavigationSection";
import UserContext from "../contexts/UserContext";
import MerchantContext from "../contexts/MerchantContext";
import { PORTAL_CODES_MERCHANT_ID } from "../utils/permissions";
import { TooltipProvider } from "@/components/ui/tooltip";

const NestedSideMenu = (): JSX.Element => {
  const { hasPalommaOnlyAccess: isPalommaUser } = useContext(UserContext);
  const { merchantType, merchantId } = useContext(MerchantContext);
  const isDevelopment = merchantType === "development";

  const configurationMenuItems = [
    {
      path: "/configuration/pipeline",
      section: "Estados",
      icon: User,
    },
    {
      path: "/configuration/agents",
      section: "Agentes",
      icon: Bot,
    },
    {
      path: "/configuration/projects",
      section: "Proyectos",
      icon: Building2,
    },
    {
      path: "/configuration/lead-qualification",
      section: "Calificación de Leads",
      icon: CheckCircle,
    },
    {
      path: "/configuration/integrations",
      section: "Integraciones",
      icon: Puzzle,
    },
    {
      path: "/configuration/assignment",
      section: "Asignación",
      icon: Users,
    },
    {
      path: "/configuration/whatsapp",
      section: "WhatsApp",
      icon: WhatsAppIcon,
    },
    {
      path: "/configuration/templates",
      section: "Plantillas de WhatsApp",
      icon: FileText,
    },
    {
      path: "/configuration/users",
      section: "Usuarios",
      icon: AtSign,
    },
    {
      path: "/configuration/schedules",
      section: "Horarios para Citas",
      icon: Clock,
    },
    {
      path: "/configuration/inbound-campaign-rules",
      section: "Pauta",
      icon: Target,
    },
    {
      path: "/configuration/auditoria",
      section: "Auditoría",
      icon: History,
    },
    {
      path: "/configuration/portal-codes",
      section: "Códigos de Portales",
      icon: FileSpreadsheet,
    },
  ].filter((item) => {
    // Agents menu item is Palomma-only
    if (item.path === "/configuration/agents") {
      return isPalommaUser;
    }
    // Projects menu item is Palomma-only AND only for development merchants
    if (item.path === "/configuration/projects") {
      return isPalommaUser && isDevelopment;
    }
    // Portal codes upload is exclusive to one merchant
    if (item.path === "/configuration/portal-codes") {
      return merchantId === PORTAL_CODES_MERCHANT_ID;
    }
    return true;
  });

  return (
    <div className="sticky top-0 flex h-screen min-h-screen w-[200px] justify-start border-r-[1.5px] border-gray-primary bg-gray-50">
      <TooltipProvider delayDuration={500}>
        <div className="flex w-full flex-col justify-start">
          <div className="mb-4 border-b border-gray-primary p-4">
            <div className="text-lg font-bold text-gray-700">
              Configuración
            </div>
          </div>

          <ul className="space-y-2 px-4">
            {configurationMenuItems.map((item) => (
              <NavigationSection
                key={item.path}
                path={item.path}
                section={item.section}
                showText={true}
                icon={item.icon}
              />
            ))}
          </ul>
        </div>
      </TooltipProvider>
    </div>
  );
};

export default NestedSideMenu;
